<template>
   <div class="home" >
    <c-banner/>
    <c-gallery />
    <c-company />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import cBanner from '@/views/Projects/Nebula/Banner.vue'
import cLightTowers from '@/views/Projects/Nebula/LightTowers.vue'
import cGallery from '@/views/Projects/Nebula/Gallery.vue'
import cCompany from '@/views/Projects/Nebula/Company.vue'

export default {
  name: 'Project',
  computed: {
    ...mapState({
      isLoading: state => state.preloader.isLoading
    })
  },
  components: {
    cBanner,
    cLightTowers,
    cGallery,
    cCompany
  },

  mounted () {

  },
  methods: {
    ...mapActions(['actionPreloader'])
  }
}
</script>
